import { useEffect } from "react";
export const ACHDocusign = () => {
  useEffect(() => {
    const { search } = location || {};
    if (search) {
      const { origin } = window.parent.location;
      const parsed = search.replace('?', '').split('=');
      if (parsed[1] === 'signing_complete') {
        window.parent.postMessage('ach-docusign-success', origin);
      } else {
        window.parent.postMessage('ach-docusign-fail', origin);
      }
    }
  }, []);
  return (<></>)
}